export default __webpack_public_path__ + "static/media/bateria1.c13678cb.png";